import ms from 'ms';

export const RESEND_COOLDOWN_MS = ms('30s');

export type CreateAccountEmailVerificationSlice = {
    resendCooldown: {
        /** Timestamp (ms) when the resend cooldown expires. Null when not active. */
        completionTime: number | null;
    };
    sendOtp: {
        error: Error;
        submitted: boolean;
        success: boolean;
    };
    /** This is a temporary user id that is used to identify the user in the backend before the user is created */
    unregisteredUserId: number | null;
    verifyOtp: {
        error: Error;
        submitted: boolean;
        success: boolean;
    };
};

export const defaultCreateAccountEmailVerificationSlice: CreateAccountEmailVerificationSlice = {
    resendCooldown: {
        completionTime: null,
    },
    sendOtp: {
        error: null,
        submitted: false,
        success: false,
    },
    unregisteredUserId: null,
    verifyOtp: {
        error: null,
        submitted: false,
        success: false,
    },
};

export type SendEmailVerificationCodePayload = {
    email: string;
};

export type SendEmailVerificationCodeResult = {
    cooldownCompletionTime: number;
    unregisteredUserId: number;
};
export type SubmitEmailVerificationCodePayload = {
    onSuccess: () => void;
    otp: string;
};
